import Repository from "./Repository";

const CREATENEWSLETTER = "create";
const GETNEWSLETTER = "get";
const SUBSCRIBE = "subscribe";
const MEDICALTHOUGHTS = "medicalThoughts";

export default {
  createNewsletter(payload) {
    return Repository.post(transformRoute(CREATENEWSLETTER), payload);
  },
  getNewsletter(payload) {
    return Repository.post(transformRoute(GETNEWSLETTER), payload);
  },
  subscribeToNewsletter(payload) {
    return Repository.post(transformRoute2(SUBSCRIBE), payload);
  },

  medicalThoughts(payload) {
    return Repository.post(transformRoute(MEDICALTHOUGHTS), payload);
  },
};

const transformRoute = (route) => {
  return `/newsletter/${route}`;
};
const transformRoute2 = (route) => {
  return `/elearning/caregiver/newsletter/${route}`;
};
